import React from "react";

import { type FieldType } from "../../../_lib/_store";

interface FormPreviewProps {
  field: FieldType;
  showLabel?: boolean;
}

export const FormPreview = ({ field, showLabel = true }: FormPreviewProps) => {
  const selectOptions =
    field.options?.map((option) => ({
      value: option,
      label: option,
    })) || [];

  return (
    <div className="form-preview-field">
      {showLabel && (
        <div className="form-preview-label">
          <span className="form-preview-label-text">
            {field.label}
            {field.required && <span className="form-preview-required">*</span>}
          </span>
        </div>
      )}

      {field.type === "textarea" ? (
        <textarea
          placeholder={field.placeholder}
          disabled
          rows={4}
          className="form-preview-textarea"
        />
      ) : field.type === "select" ? (
        <div style={{ marginBottom: "8px", width: "100%" }}>
          <select
            disabled
            defaultValue=""
            style={{
              width: "100%",
              padding: "8px",
              borderRadius: "4px",
              border: "1px solid #ccc",
              backgroundColor: "#f5f5f5",
            }}
          >
            <option value="" disabled>
              {field.placeholder || "Select an option"}
            </option>
            {selectOptions.map((option, index) => (
              <option key={index} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
      ) : field.type === "radio" ? (
        <div style={{ marginTop: "8px", width: "100%" }}>
          {field.options?.map((option, index) => (
            <div key={index} style={{ marginBottom: "8px" }}>
              <label style={{ display: "inline-flex", alignItems: "center" }}>
                <input
                  type="radio"
                  id={`${field.id}-${index}`}
                  name={field.id}
                  disabled
                />
                <span style={{ marginLeft: "8px" }}>{option}</span>
              </label>
            </div>
          ))}
        </div>
      ) : field.type === "checkbox" ? (
        <div style={{ marginTop: "8px", width: "100%" }}>
          {field.options?.map((option, index) => (
            <div key={index} style={{ marginBottom: "8px" }}>
              <label style={{ display: "inline-flex", alignItems: "center" }}>
                <input
                  type="checkbox"
                  id={`${field.id}-checkbox-${index}`}
                  name={`${field.id}-checkbox-${index}`}
                  disabled
                />
                <span style={{ marginLeft: "8px" }}>{option}</span>
              </label>
            </div>
          ))}
        </div>
      ) : field.type === "file" ? (
        <input
          type="file"
          disabled
          style={{
            width: "100%",
            padding: "8px",
            borderRadius: "4px",
            border: "1px solid #ccc",
            backgroundColor: "#f5f5f5",
          }}
        />
      ) : (
        <input
          type={
            field.type === "email"
              ? "email"
              : field.type === "number"
                ? "number"
                : field.type === "date"
                  ? "date"
                  : "text"
          }
          placeholder={field.placeholder}
          disabled
          style={{
            width: "100%",
            padding: "8px",
            borderRadius: "4px",
            border: "1px solid #ccc",
            backgroundColor: "#f5f5f5",
          }}
        />
      )}
    </div>
  );
};
